import { CHAT_SET_NUM_UNREAD_CONVERSATIONS } from './actions';
import { currentUserIdSelector } from '../Auth/selectors';

import Resource from '../../resource/Resource';

import './storeInitialiser';

export function retrieveNumUnreadMessages() {
  return (dispatch, getState) => {
    const userId = currentUserIdSelector(getState());
    Resource.read('user', userId, 'getNumUnreadMessages').then(
      (numUnreadConversations) => {
        dispatch({
          type: CHAT_SET_NUM_UNREAD_CONVERSATIONS,
          numUnreadConversations,
        });
      }
    );
  };
}
